var render = function render(){var _vm=this,_c=_vm._self._c,_setup=_vm._self._setupProxy;return _c('v-btn',{staticClass:"my-1",attrs:{"color":"warning","small":"","loading":_setup.generatingPdf},on:{"click":_setup.generatePdf}},[_c('font-awesome-icon',{staticClass:"me-2",attrs:{"icon":"fas fa-file-export"}}),_vm._v(_vm._s(_vm.booyong ? 'Export For Booyong' : 'Export'))],1)
}
var staticRenderFns = []

export { render, staticRenderFns }